package com.anjuros.website.redesign.sections.pricing

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdPrimaryButton
import com.anjuros.website.redesign.styles.PricingQuoteBodyStyle
import com.anjuros.website.redesign.styles.PricingQuoteFreeStyle
import com.anjuros.website.redesign.styles.PricingQuoteHeadStyle
import com.anjuros.website.redesign.styles.PricingQuoteLinesStyle
import com.anjuros.website.redesign.styles.PricingQuoteNoteStyle
import com.anjuros.website.redesign.styles.PricingQuoteStyle
import com.anjuros.website.redesign.styles.PricingQuoteTotalStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Aside
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Small
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/**
 * Trade-style quote for the chosen website and care plan. Nothing is due today:
 * the website is paid once you're happy, and Full Service is free for the first 2 months.
 */
@Composable
fun PricingQuoteSheet(website: WebsiteOption, plan: CarePlan) {
    val from = if (website.fromPrice) LocalText(RdText.PRICE_FROM) + " " else ""
    val websitePrice = from + LocalText(website.price)
    val planPrice = LocalText(plan.price)
    val summary = LocalText(if (plan == CarePlan.FULL) RdText.QUOTE_SUMMARY_FULL else RdText.QUOTE_SUMMARY_OTHER)
        .replace("%website", websitePrice)
        .replace("%plan", LocalText(plan.title))
        .replace("%price", planPrice)

    Aside(PricingQuoteStyle.toModifier().attrsModifier { attr("aria-live", "polite"); attr("aria-labelledby", "quote-title") }.toAttrs()) {
        Div(PricingQuoteHeadStyle.toModifier().toAttrs()) {
            B({ id("quote-title") }) { Text(LocalText(RdText.QUOTE_TITLE)) }
            Span { Text(LocalText(RdText.QUOTE_SUBTITLE)) }
        }
        Div(PricingQuoteBodyStyle.toModifier().toAttrs()) {
            Ul(PricingQuoteLinesStyle.toModifier().toAttrs()) {
                QuoteLine(LocalText(website.title), websitePrice, LocalText(RdText.QUOTE_WEBSITE_NOTE))
                Li {
                    Span { Text(LocalText(RdText.QUOTE_FREE_LINE)) }
                    Span(PricingQuoteFreeStyle.toModifier().toAttrs()) { Text(LocalText(RdText.QUOTE_FREE)) }
                    Small { Text(LocalText(RdText.QUOTE_FREE_NOTE)) }
                }
                QuoteLine(LocalText(plan.title), planPrice + LocalText(RdText.PRICE_PER_MONTH_SHORT), LocalText(RdText.QUOTE_PLAN_NOTE))
            }
            Div(PricingQuoteTotalStyle.toModifier().toAttrs()) {
                Span { Text(LocalText(RdText.QUOTE_DUE_TODAY)) }
                B { Text(LocalText(RdText.QUOTE_DUE_AMOUNT)) }
            }
            P(PricingQuoteNoteStyle.toModifier().toAttrs()) { Text(summary) }
            RdPrimaryButton(RdRoute.CONTACT, RdText.CTA_FREE_PREVIEW, withArrow = true)
        }
    }
}

@Composable
private fun QuoteLine(item: String, amount: String, note: String) {
    Li {
        Span { Text(item) }
        Span { Text(amount) }
        Small { Text(note) }
    }
}
